import Skeleton from 'react-loading-skeleton';

const ResultsFilterSkeleton = () => (
  <div className="search-inner">
    <div className="hotel-result-filter">
      <div className="hotel-result-filter-row">
        <div className="hotel-result-filter-input name">
          <Skeleton height={48} />
        </div>
        <div className="hotel-result-filter-input rooms">
          <Skeleton height={48} />
        </div>
        <div className="hotel-result-filter-input additional">
          <Skeleton height={48} />
        </div>
        <div className="hotel-result-filter-input star">
          <Skeleton height={48} />
        </div>
        <div className="hotel-result-filter-input location">
          <Skeleton height={48} />
        </div>

        <div className="hotel-result-filter-input prices">
          <Skeleton height={48} />
        </div>
      </div>
      <ButtonsSkeleton />
    </div>
  </div>
);

export default ResultsFilterSkeleton;

export const ButtonsSkeleton = () => {
  return (
    <div className="hotel-result-filter-row hotel-result-sort-by">
      <div className="sort-by-buttons show-laptop-sm">
        <span style={{ flex: '0 0 calc(33.33% - 3px)' }}>
          <Skeleton height={38} />
        </span>
        <span style={{ flex: '0 0 calc(33.33% - 3px)' }}>
          <Skeleton height={38} />
        </span>
        <span style={{ flex: '0 0 calc(33.33% - 3px)' }}>
          <Skeleton height={38} />
        </span>
      </div>
    </div>
  );
};
